// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"30":"e6808f8c","144":"28143e70"}[chunkId] + ".chunk.css";
};